import { Controller } from "@hotwired/stimulus"

// Debounced auto-submit for GET filter/search forms.
// - Submits after typing pauses.
// - Submits immediately on Enter.
// - Keeps clear/delete behavior responsive by submitting blank values too.
export default class extends Controller {
  static values = {
    delay: { type: Number, default: 400 }
  }

  connect() {
    this.submitTimeout = null
    this.composing = false
  }

  disconnect() {
    this.clearTimeout()
  }

  queueSubmit() {
    if (this.composing) return

    this.clearTimeout()
    this.submitTimeout = setTimeout(() => {
      this.submitTimeout = null
      this.requestSubmit()
    }, this.delayValue)
  }

  submitNow(event) {
    if (event.key !== "Enter" || event.isComposing || this.composing) return

    event.preventDefault()
    this.clearTimeout()
    this.requestSubmit()
  }

  startComposition() {
    this.composing = true
    this.clearTimeout()
  }

  endComposition() {
    this.composing = false
    this.queueSubmit()
  }

  requestSubmit() {
    const form = this.element.form
    if (!form) return

    if (form.closest("[data-controller~='browse-filter-form']")) {
      form.querySelector("input[name='page']")?.remove()
      form.dataset.browseFilterAction = new URL(window.location.href).searchParams.has("q") ? "replace" : "advance"
      form.dataset.browseFilterSubmission = "filter"
    }

    form.requestSubmit()
  }

  clearTimeout() {
    if (!this.submitTimeout) return

    clearTimeout(this.submitTimeout)
    this.submitTimeout = null
  }
}
